export const environment = {
    production: process.env.PRODUCTION === 'true',
    FONT_AWESOME_4: process.env.FONT_AWESOME_4,
    API_DG_URL: process.env.API_DG_URL,
    API_SECONDARY_URL: process.env.API_SECONDARY_URL,
    API_SAVE_URL: process.env.API_SAVE_URL,
    CODE_SAVELOG: process.env.CODE_SAVELOG,
    API_DG_KEY: process.env.API_DG_KEY,
    BLOB_URL: process.env.BLOB_URL,
    BASE_URL:process.env.BASE_URL,
    MESSAGE_ORIGIN:process.env.MESSAGE_ORIGIN,
    FRAMEDOWN_CLASS: process.env.FRAMEDOWN_CLASS,
    ACCOUNTKEY: process.env.ACCOUNTKEY
}
